import { render, staticRenderFns } from "./fotoMapa.vue?vue&type=template&id=92ce73d2"
import script from "./fotoMapa.vue?vue&type=script&lang=js"
export * from "./fotoMapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports